var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-UX-(New)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_New-Update-(Desktop)",
    transform: "translate(-19.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(0.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(6.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transfer-Icon",
    transform: "translate(13.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Transfer-Icon-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 3.000000)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5040147,0.0613336265 C13.6875285,0.404116693 14.7736925,1.01915102 15.6649195,1.84456729 L15.8836086,2.05526852 L18.5468797,4.561 L18.547619,1.39285716 C18.547619,1.06740365 18.7894652,0.798436341 19.1032443,0.755868549 L19.1904762,0.750000021 C19.5159297,0.750000021 19.784897,0.991846206 19.8274648,1.30562526 L19.8333333,1.39285716 L19.8333333,6.10714288 C19.8333333,6.43259639 19.5914871,6.7015637 19.2777081,6.74413149 L19.1904762,6.75000002 L14.4761905,6.75000002 C14.1211503,6.75000002 13.8333333,6.46218307 13.8333333,6.10714288 C13.8333333,5.78168937 14.0751795,5.51272205 14.3889586,5.47015426 L14.4761905,5.46428574 L17.5428797,5.463 L14.9697859,3.04182054 C14.1841941,2.25480069 13.2115012,1.6794037 12.1424655,1.36977712 C11.0725441,1.05989397 9.94138673,1.02644253 8.85496482,1.27258269 C7.76926643,1.51855892 6.76402618,2.03564261 5.93311404,2.77513744 C5.6563121,3.02148551 5.23685845,2.99145635 4.99623809,2.70806543 C4.75561773,2.42467451 4.7849487,1.99523621 5.06175064,1.74888814 C6.06023641,0.860256204 7.26647729,0.239780159 8.56799131,-0.0550913413 C9.86878156,-0.349798866 11.2227613,-0.309757952 12.5040147,0.0613336265 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19047619,8.75000002 C5.54551639,8.75000002 5.83333333,9.03781697 5.83333333,9.39285716 C5.83333333,9.71831068 5.59148715,9.98727799 5.2777081,10.0298458 L5.19047619,10.0357143 L2.253,10.0351307 L4.97783917,12.4581796 C5.80881379,13.2451999 6.8376972,13.8205972 7.96848814,14.1302235 C9.10021635,14.4401064 10.2967185,14.4735576 11.4459016,14.2274173 C12.5943175,13.9814414 13.6576289,13.464357 14.5365422,12.7248615 C15.4140513,11.9865475 16.0791131,11.0506432 16.4701443,10.0045952 C16.6021375,9.65149975 17.0048756,9.46882526 17.3696848,9.59658031 C17.7344941,9.72433536 17.9232287,10.1141417 17.7912355,10.4672371 C17.3186038,11.731575 16.5158127,12.8612978 15.4582427,13.7511106 C14.4020754,14.6397431 13.126152,15.2602199 11.749453,15.5550912 C10.373518,15.8497988 8.94132146,15.8097582 7.58605291,15.4386668 C6.33417047,15.095884 5.185261,14.4808494 4.24254909,13.6554327 L4.01122663,13.4447314 L1.118,10.8711307 L1.11904762,14.1071429 C1.11904762,14.4325964 0.877201435,14.7015637 0.563422383,14.7441315 L0.476190476,14.75 C0.150736963,14.75 -0.118230347,14.5081538 -0.160798139,14.1943748 L-0.166666667,14.1071429 L-0.166666667,9.39285716 C-0.166666667,9.06740365 0.0751795176,8.79843634 0.38895857,8.75586855 L0.476190476,8.75000002 L5.19047619,8.75000002 Z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfers);
export default __webpack_public_path__ + "static/media/Transfers.a4c396bb7126bafdd84f2bc6fdca800a.svg";
export { ForwardRef as ReactComponent };